/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */
import actions from '@/store/modules/ui/actions'
import axios from 'axios'
import { randomInRange } from '@/helpers'
import Config from 'config'

actions.loadRightActiveComponent = (ctx, { component, isBack = false, props = {} }) => {
  let loader = setTimeout(() => {
    ctx.commit('setShowRightLoader', true)
  }, 1000)

  if (isBack) {
    // pop
    ctx.commit('popRightNavHistory')
    if (ctx.state.rightNavHistory.length) {
      const popped = ctx.state.rightNavHistory[ctx.state.rightNavHistory.length - 1]
      ctx.commit('setRightActiveComponent', popped)
    }
  } else {
    component.then(res => {
      clearTimeout(loader)
      // push
      let respComponent = {
        component: res.default,
        props: props
      }
      ctx.commit('pushRightNavHistory', respComponent)
      ctx.commit('setRightActiveComponent', respComponent)
    }).catch(res => {
      clearTimeout(loader)
      console.log('errors', res)
    })
  }
}

actions.loadLeftActiveComponent = (ctx, { component, isBack = false, props = {} }) => {
  let loader = setTimeout(() => {
    ctx.commit('setShowLeftLoader', true)
  }, 1000)

  if (isBack) {
    // pop
    ctx.commit('popLeftNavHistory')
    if (ctx.state.leftNavHistory.length) {
      const popped = ctx.state.leftNavHistory[ctx.state.leftNavHistory.length - 1]
      ctx.commit('setLeftActiveComponent', popped)
    }
  } else {
    component.then(res => {
      clearTimeout(loader)
      // push
      let respComponent = {
        id: randomInRange(),
        component: res.default,
        props: props
      }
      ctx.commit('pushLeftNavHistory', respComponent)
      ctx.commit('setLeftActiveComponent', respComponent)
    }).catch(res => {
      clearTimeout(loader)
      console.log('loadLeftActiveComponent --> errors', res)
    })
  }
}

actions.loadTopActiveComponent = (ctx, { component, isBack = false, props = {} }) => {
  let loader = setTimeout(() => {
    ctx.commit('setShowTopLoader', true)
  }, 1000)

  if (isBack) {
    // pop
    ctx.commit('popTopNavHistory')
    if (ctx.state.topNavHistory.length) {
      const popped = ctx.state.topNavHistory[ctx.state.topNavHistory.length - 1]
      ctx.commit('setTopActiveComponent', popped)
    }
  } else {
    component.then(res => {
      clearTimeout(loader)
      // push
      let respComponent = {
        id: randomInRange(),
        component: res.default,
        props: props
      }
      ctx.commit('pushTopNavHistory', respComponent)
      ctx.commit('setTopActiveComponent', respComponent)
    }).catch(res => {
      clearTimeout(loader)
      console.log('errors', res)
    })
  }
}

actions.loadBottomActiveComponent = (ctx, { component, isBack = false, props = {} }) => {
  let loader = setTimeout(() => {
    ctx.commit('setShowBottomLoader', true)
  }, 1000)

  if (isBack) {
    // pop
    ctx.commit('popBottomNavHistory')
    if (ctx.state.bottomNavHistory.length) {
      const popped = ctx.state.bottomNavHistory[ctx.state.bottomNavHistory.length - 1]
      ctx.commit('setBottomActiveComponent', popped)
    }
  } else {
    component.then(res => {
      clearTimeout(loader)
      // push
      let respComponent = {
        id: randomInRange(),
        component: res.default,
        props: props
      }
      ctx.commit('pushBottomNavHistory', respComponent)
      ctx.commit('setBottomActiveComponent', respComponent)
    }).catch(res => {
      clearTimeout(loader)
      console.log('errors', res)
    })
  }
}

actions.loadSubMenuActiveComponent = (ctx, { component, isBack = false, props = {} }) => {
  let loader = setTimeout(() => {
    ctx.commit('setShowSubMenuLoader', true)
  }, 1000)

  if (isBack) {
    // pop
    ctx.commit('popSubMenuHistory')
    if (ctx.state.topNavHistory.length) {
      const popped = ctx.state.topNavHistory[ctx.state.topNavHistory.length - 1]
      ctx.commit('setSubMenuActiveComponent', popped)
    }
  } else {
    component.then(res => {
      clearTimeout(loader)
      // push
      let respComponent = {
        component: res.default,
        props: props
      }
      ctx.commit('pushSubMenuHistory', respComponent)
      ctx.commit('setSubMenuActiveComponent', respComponent)
    }).catch(res => {
      clearTimeout(loader)
      console.log('errors', res)
    })
  }
}

actions.geolocateWithGoogle = (ctx) => {
  let url = Config.API.google.geolocate
  url = url.replace('{{api_key}}', process.env.VUE_APP_GOOGLE_API)
  return axios.post(url)
}

// Calculate distance between two points
// lat-lng
actions.calcDistance = (ctx, { point1 = null, point2 = null }) => {
  // https://developers.google.com/maps/documentation/javascript/distancematrix
  // Parsing result -> https://developers.google.com/maps/documentation/javascript/distancematrix#distance_matrix_parsing_the_results
  if (point1 && point2) {
    let url = Config.API.google.distances
    url = url.replace('{{origins}}', point1)
      .replace('{{destinations}}', point2)
      .replace('{{api_key}}', process.env.VUE_APP_GOOGLE_API)
    return axios.post(url)
  } else {
    return false
  }
}

// Reverse Geocoding
// lat-lng
actions.reverseGeocode = async (ctx, { lat = null, lng = null, resultType = '', language = '' }) => {
  if (lat && lng) {
    let url = Config.API.google.geocode
    url = url.replace('{{lat}}', lat)
      .replace('{{lng}}', lng)
      .replace('{{resultType}}', resultType)
      .replace('{{language}}', language)
      .replace('{{api_key}}', process.env.VUE_APP_GOOGLE_API)
    return axios.post(url)
  } else {
    return false
  }
}

actions.loadGenericModalComponent = (ctx, { title = '', component, props = {}, modalProps = {} }) => {
  component.then(res => {
    let respComponent = {
      id: randomInRange(),
      component: res.default,
      props: props
    }
    ctx.commit('setGenericModalComponent', { title, componentToRender: respComponent, modalProps })
  }).catch(res => {
    console.log('errors', res)
  })
}

actions.loadMenu = (ctx) => {
  // load categories
  if (ctx.state.menu.length) {
    return Promise.resolve(ctx.state.menu)
  } else {
    return ctx.dispatch('category/load', {}, { root: true })
      .then(res => {
        ctx.commit('saveMenu', res)
        return ctx.state.menu
      })
  }
}

export default {
  ...actions
}
